<template>
    <div>
        <!-- <headerNav title="百科知识" /> -->
        <searchtop placeholder="搜索感兴趣的育儿知识" :showbtn="false" :disabled="true" @doClick="doClick"></searchtop>
        <van-tabs v-model="active" :color="$abctheme.basecolor" :swipeable="true">
            <!-- <van-tab title="要点">
                <div class="fmian" @click="godetail()">
                    <div class="fb" >
                        <div class="fb-img">
                            <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                        </div>
                        <div class="fb-wz">
                            <div class="fb-wz-tit">成长须知|2岁11个月宝宝的发育特点成长须知|2岁11个月宝宝的发育特点成长须知|2岁1</div>
                            <div class="fb-wz-stit">14.0万人读过</div>
                        </div>
                    </div>
                    <div class="fb">
                        <div class="fb-img">
                            <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                        </div>
                        <div class="fb-wz">
                            <div class="fb-wz-tit">成长须知|2岁11个月宝宝的发育特点成长须知|2岁11个月宝宝的发育特点成长须知|2岁1</div>
                            <div class="fb-wz-stit">14.0万人读过</div>
                        </div>
                    </div>
                    <div class="fb">
                        <div class="fb-img">
                            <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                        </div>
                        <div class="fb-wz">
                            <div class="fb-wz-tit">成长须知|2岁11个月宝宝的发育特点成长须知|2岁11个月宝宝的发育特点成长须知|2岁1</div>
                            <div class="fb-wz-stit">14.0万人读过</div>
                        </div>
                    </div>
                </div>
               
            </van-tab> -->
            <van-tab v-for="(item,index) in wikilist"  :key="index" :title="item.title">
                <div class="yqmian" v-if="item.expand">
                    <div class="flist" v-for="(vitem,vindex) in item.children" :key="vindex">
                        <van-row>
                            <van-col :span="24" class="yqtit">
                                <span class="mtit">{{vitem.title}}</span>
                            </van-col>
                        </van-row>
                        <div class="btns" v-if="vitem.expand">
                             <div class="fbtn" v-for="(fitem,findex) in vitem.children" :key="findex" @click="gopage(fitem)">{{fitem.title}}</div>
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import searchtop from '@/components/search/searchtop.vue';
export default {
    components:{
        searchtop
    },
    data(){
        return{
            active:0,
            wikilist:[]
        }
    },
    created()
    {
        this.queryinfo();
    },
    methods:{
        queryinfo()
        {
            this.ajax.post('/api/services/app/PhoneWiki/QueryWikiAll').then(x=>
            {
                this.wikilist=x.result;
            });
        },
        gopage(item){
            this.$router.push({path:'wikiarticle',query:{id:item.id}})
        },
        doClick()
        {
            this.$router.push({path:'wikisearch'})
        }
    }
}
</script>
<style lang="scss" scoped>

.fmian{
    font-size: 14px;
    background-color: #fff;
    
}
.fb{
    padding-top:5px;
    margin-right: 5px;
    margin-left: 5px;
}
.fb-img{
    position: absolute;
}
.fb-img img
{
    width: 100px;
}

.fb-wz{
    min-height: 75px;
    padding-left:110px;
    position: relative;
}
.fb-wz-tit{
    font-size: 15px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box; 
    white-space:pre-wrap;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
.fb-wz-stit{
    position: absolute;
    bottom: 5px;
    font-size: 12px;
    color:#6f6f6f;
}
.mtit::before{
    content: "|";
    position: absolute;
    left:0;
    top:-4px;
    font-size: 14px;
    font-weight:bolder;
    color:#FDD108;
}
.yqmian{
    background-color: #fff;
    padding: 5px 0 10px 0;
    color:black;
}
.flist{ 
    margin: 8px 10px;
    font-size: 14px;
}
.yqtit{
    margin-bottom: 10px;
}
.mtit{
    position: relative;
    padding-left:10px;
    font-size: 12px;
}
.btns{
    text-align: left;
    font-size: 13px;
    
}
.btns .fbtn
{
    display: inline-block;
    text-align: center;
    width: 30%;
    margin-left:2%;
    margin-bottom: 8px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
}
</style>